import React, {Component} from "react";
import ItemsLoader from "./ItemsLoader";
import Comments from "./Comments";
import "./Styles/itemsTable.css";


class Wishlist extends Component<any, any>{

    render() {
        return <div className="WishlistPage">
            <header className="App-header">
                <p className="WishlistPage-title">Wishlist</p>
            </header>

            <ItemsLoader/>

            <header className="App-header">
                <p className="WishlistPage-title WishlistPage-title--sub">Комментарии</p>
            </header>
            <div className="Comments">
                <Comments type="wishlist"/>
            </div>
        </div>;
    }
}


export default Wishlist
